import React from 'react';
import classNames, { Argument } from 'classnames';
import BaseIcon from 'common/BaseIcon';

type CheckboxProps = {
  id?: string;
  value: boolean;
  isLeft?: boolean;
  labelProps?: React.LabelHTMLAttributes<HTMLLabelElement> & { 'data-cy'?: string };
  className?: Argument;
  classNameWrapper?: Argument;
  children?: React.ReactNode;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'className'>;

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  value,
  className,
  classNameWrapper,
  labelProps,
  isLeft = true,
  children,
  ...rest
}) => (
  <div className={classNames(classNameWrapper, 'default-checkbox')}>
    <input
      id={id}
      type="checkbox"
      className={classNames(className, { left: isLeft, right: !isLeft })}
      checked={value}
      tabIndex={0}
      {...rest}
    />
    <label {...labelProps} htmlFor={id} aria-hidden="true">
      <BaseIcon icon="check" className={classNames('d-none fb-icon text-white checkbox__check', { left: isLeft, right: !isLeft })} />
      {children}
    </label>
  </div>
);

export default Checkbox;
